export default __webpack_public_path__ + "static/media/foto-bienvenida.d9405db2.jpg";